<template>
  <div id="newsEdit">
    <app-menu></app-menu>
    <div class="col-lg-10 offset-lg-1">
      <h3 class="text-center pb-lg-4">Album</h3>
      <div class="col-lg-6">
        <div class="form-group">
          <label for="exampleSelect1">Vyberte ročník:</label>
          <select class="form-control" v-model="album.periodId" id="exampleSelect1">
            <option v-for="period in periods" v-bind:key="period.id" v-bind:value="period.id">
              {{ period.name.cs }}
            </option>
          </select>
        </div>
      </div>
      <div class="row pt-lg-5">
        <div class="col-lg-6">
          <h4 class="text-center">Čestina</h4>
          <div class="form-group">
            <label>Název alba:</label>
            <input type="text" class="form-control" v-model="album.name.cs" placeholder="Název alba">
          </div>
        </div>
        <div class="col-lg-6">
          <h4 class="text-center">Angličtina</h4>
          <div class="form-group">
            <label>Název alba:</label>
            <input type="text" class="form-control" v-model="album.name.en" placeholder="Název alba">
          </div>
        </div>
      </div>
      <div class="row pt-lg-4">
        <div class="col-lg-6">
          <h5 class="text-center">Foto - náhled:</h5>
          <div class="form-group pt-lg-4">
            <input type="file" class="form-control-file pt-lg-4" accept="image/jpeg" @change="selectMainImage"
                   aria-describedby="fileHelp">
            <small class="form-text text-muted"></small>
          </div>
          <a v-if="mainImage.length > 0" class="closeButton" type="button" v-on:click="deleteMainPhoto()"
             :id="mainImage">✕</a>
          <img v-if="mainImage.length > 0" class="img-fluid" width="50%" :src="mainImage">
        </div>
        <div class="col-lg-6">
          <h5 class="text-center">Foto - ostatní:</h5>
          <div class="form-group pt-lg-4 tex">
            <input type="file" class="form-control-file pt-lg-4" multiple="multiple" accept="image/jpeg" @change="selectImages"
                   aria-describedby="fileHelp">
            <small class="form-text text-muted"></small>
          </div>
          <div v-for="(image, index) in images" v-bind:key="index">
            <a class="closeButton" type="button" v-on:click="deletePhoto(image)" :id="index">✕</a>
            <img class="img-fluid pb-lg-2" width="50%" :src="image">
          </div>
        </div>
      </div>
      <div class="form-check form-switch pt-lg-4 text-center">
        <input id="visible" v-model="album.visible" class="form-check-input" type="checkbox">
        <label class="form-check-label" for="visible">Viditelný</label>
      </div>
      <div class="text-center pt-lg-4">
        <send-button
            :send="create"
            text="Uložit Album"
            :response="error"
        />
      </div>
    </div>
    <error-modal :message="error"/>
  </div>
</template>

<script>
import AdminMenu from "@/components/admin/AdminMenu";
import axios from "@/api/axiom-instance";
import config from "@/config"
import ErrorModal from "@/components/admin/ErrorModal";
import SendButton from "@/components/admin/SendButton";

export default {
  name: "newsEdit",
  components: {
    'app-menu': AdminMenu,
    'error-modal': ErrorModal,
    'send-button': SendButton
  },
  data() {
    return {
      album: {name: {}},
      mainImage: "",
      images: [],
      periods: [],
      error: null
    }
  },
  created() {
    axios
        .get("/period/list")
        .then((success) => {
          this.periods = success.data
        }).catch((error) => this.error = error)

    if (this.$route.params.id != null) {
      this.load(this.$route.params.id)
    }
  },
  methods: {
    create: function () {
      axios.post("/album", this.album).then((success) => {
        axios.post("/image", {name: success.data.id, type: "album-main", data: this.mainImage}).then(() => {
          axios.post("/image/bulk", {name: success.data.id, type: "album-others", data: this.images}).then(() => {
            this.$router.push({path: "/admin/album"})
          }).catch(error => this.error = error)
        }).catch(error => this.error = error)

      }).catch(error => this.error = error)
    },
    selectMainImage: function (e) {
      const reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      reader.onload = e => {
        this.mainImage = e.target.result
      }
    },
    selectImages: function (e) {
      e.target.files.forEach(data => {
        const reader = new FileReader()
        reader.readAsDataURL(data)
        reader.onload = e => {
          this.images.push(e.target.result)
        }
      })
    },
    load: function (id) {
      axios
          .get("/album", {params: {id: id}})
          .then((success) => {
            this.album = success.data;
          }).catch(error => this.error = error)
      this.mainImage = config.API_URL + "/image?type=album-main&name=" + id
      axios
          .get("/image/list", {params: {type: "album-others/" + id}})
          .then((success) => {
            this.images = success.data.map(it => it.src)
          }).catch(error => this.error = error)
    },
    deleteMainPhoto: function () {
      this.mainImage = "";
    },
    deletePhoto: function (value) {
      this.images = this.images.filter(it => it !== value);
    }
  }
}
</script>

<style scoped>
.noneVisible {
  display: none;
}

#newsEdit {
  min-height: 100vh;
  padding-bottom: 4em;
  overflow: hidden;
}

.closeButton {
  position: absolute;
  background-color: black;
  color: white;
  padding: 3px 7px;
}
</style>
